import Vue from "vue";
import {
    reactive,
    toRefs,
    computed,
    provide,
    inject
} from "@vue/composition-api";
import axios from "axios";
import {
    task_assignees,
    task_order,
    toolbar_search
} from "../../api";
import {getters as UserGetters} from "./user";
import {state as accountState, getters as AccountGetters} from "./account";
import {actions as appActions, myDebug} from "../../store/modules/app";
import {
    parseSysDate,
    formatSysDate,
    formatSysDateTime
} from "@/plugins/formatting";
import {get} from '@/helpers/get-set'
import {syncItemToList} from "../../plugins/formatting";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {translatePeriods} from "@/modules/time/time";

export const state = reactive({
    lists: ["tasks", "calendar_tasks", "recurring_tasks"],
    isBulkActionLoading: false,
    selectedListIds: [],
    bulkActionErrorsTotal: null,
    markDoneErrorsTotal: null,
    saveTaskTimeEntriesErrorsTotal: null,
    deleteTasksErrors: [],
    isSameAccount: false,
    selectedAccountId: null,
    map: new Map(),
    list: [],
    total: 0,
    tasks_list: [],
    tasks_total: 0,
    tasks_filters: null,
    calendar_tasks_list: [],
    calendar_tasks_total: 0,
    calendar_tasks_filters: null,
    recurring_tasks_list: [],
    recurring_tasks_filters: null,
    projects: [],
    current_task: null,
    /*
    available_related_tasks: [],
     */
    task_dialog: {
        show: false,
        task_id: 0,
        client_id: 0,
        title: null,
        topic_id: 0,
        date: null,
        is_template: null,
        model: null,
        admin_view: false
    },
    estimation_total_list: [],
    last_snooze_date: "",
    selected_date: formatSysDate(new Date()),
    selected_date_scope: "day"
});
export const task_status = {
    VISIBLE: 1,
    DELETED: 2,
    NEW: 4,
    IN_PROGRESS: 8,
    FINISHED: 16,
    INACTIVE: 32
};
const newTask = function (
    account_id,
    client_id,
    title,
    topic_id,
    is_template,
    template_type = "task"
) {
    let recurrence_rule = null;
    let _data = null;

    let taskStartDate = new Date()

    if (is_template) {
        if (template_type === "workflow" || template_type === "project") {
            _data = {
                count_days: 0,
                date_dir: "before",
                date_field: null,
                has_due_date: 0,
                due_count_days: 0
            }
        } else {
            taskStartDate.setDate(1)

            recurrence_rule = {
                type: "monthly",
                day_of_month: new Date().getDate(),
                shift_to_workday: 0,
                date: formatSysDateTime(taskStartDate),
                date_only: 1,
                due_date_only: 1,
                has_due_date: 1,
                due_day_of_month: new Date().getDate(),
                due_shift_to_workday: 0,
                due_calc_type: "date",
                interval: 1
            }
        }
    }
    return {
        id: 0,
        virtual_id: 0,
        recurrence_id: null,
        recurrence_date: null,
        account_id: account_id,
        client_id: client_id,
        automations: [],
        project_id: null,
        project_status_from: null,
        project: null,
        assignees: template_type === "job" ? [] : [accountState.current_account.id],
        followers: [],
        title: title,
        description: null,
        status: "new",
        calc_status: "new",
        is_important: false,
        is_extra: false,
        date: formatSysDateTime(taskStartDate),
        due_date: formatSysDateTime(new Date()),
        recurrence_rule,
        checklist: null,
        estimation: null,
        finished_at: null,
        topic_id: topic_id,
        date_only: true,
        has_logs: false,
        files: [],
        has_files: false,
        due_date_only: true,
        has_due_date: false,
        tracked_time: null,
        fields: null,
        identity: null,
        bill_by: null,
        bill_at: null,
        base_task_id: null,
        timezone: accountState.current_account.timezone,
        rights: 0,
        is_cp: false,
        cp_assignees: [],
        cp_is_task: true,
        cp_auto_finish: false,
        cp_due_date_offset: 0,
        task_button: {
            icon: "🌼",
            description: "",
            is_for_everyone: 0,
        },
        depends_on: [],
        _data
    };
};

const populateListWithGroupMembers = (groups, ids) => {
    const filter_filtered_groups = groups.filter(group => ids.includes(group.id))
    const filter_assignee_ids_from_groups = filter_filtered_groups.reduce((arr, group) => {
        return [...arr, ...group.group_members]
    }, []).map(x => x.person_id)


    let filtered_complete_assignees_filter = ids.slice()
    // The value can be an array
    for (const i of filter_assignee_ids_from_groups) {
        if (Array.isArray(i)) {
            filtered_complete_assignees_filter = [...filtered_complete_assignees_filter, ...i]
        } else {
            filtered_complete_assignees_filter.push(i)
        }
    }

    return filtered_complete_assignees_filter
}

const isTaskVisibleByAssigneeFilter = function (filters, task, groups) {
    const assignee_filters = ['assigned_id', 'person_id_list']
    for (let assignee_filter of assignee_filters) {
        if (filters[assignee_filter] !== undefined && filters[assignee_filter] !== null) {
            if (task.assignees !== undefined && task.assignees) {
                //Adds all group members to filtered_complete_assignees_filter and task_complete_assignees_filter
                const filtered_complete_assignees_filter = populateListWithGroupMembers(groups, filters[assignee_filter])
                const task_complete_assignees_filter = populateListWithGroupMembers(groups, task.assignees)

                if (filtered_complete_assignees_filter.length) {
                    if (filtered_complete_assignees_filter.filter(x => task_complete_assignees_filter.indexOf(x) >= 0).length === 0) {
                        return false;
                    }
                }
            }
        }
    }
    return true
}
const isTaskVisibleByTemplateFilter = function (filters, task) {
    let is_task = task.recurrence_rule === null
    let only_templates = filters.only_templates !== undefined && filters.only_templates !== null && filters.only_templates
    return !(only_templates && is_task);
}
const isTaskVisibleByOnlyTasksFilter = function (filters, task) {
    let is_template = task.recurrence_rule !== null
    let only_tasks = filters.only_templates === undefined
    return !(only_tasks && is_template);
}
const isTaskVisibleByClientFilter = function (filters, task) {
    let client_id_list = [];
    if (filters.client_id) client_id_list.push(filters.client_id);
    if (filters.client_id_list && filters.client_id_list.length) client_id_list = client_id_list.concat(filters.client_id_list);
    if (client_id_list.length && task.client_id) {
        let client_not_found = client_id_list.indexOf(task.client_id) === -1
        if (client_not_found) {
            return false;
        }
    }
    return true
}
const isTaskVisibleByProjectFilter = (filters, task) => {
    if (filters.project_id != null) {
        if (!task.project_id) return false;
        return filters.project_id === task.project_id;
    }
    return true;
}

const isTaskVisibleByDateFilter = function (filters, task) {
    if (filters.dates_list !== undefined && Array.isArray(filters.dates_list)) {
        if (task.date !== undefined && task.date) {
            let filter_dates = filters.dates_list.slice(0, 2).map(x => parseSysDate(x));
            if (filters.dates_list.length >= 3) {
                filter_dates = [translatePeriods(filters.dates_list[2]), translatePeriods(filters.dates_list[3])]
            }

            let task_date = parseSysDate(task.date);

            let filter_start = filter_dates[0];
            let filter_end = filter_dates[1];
            if (myDebug.level() >= 2) console.log(' >>> filter period ' + filter_start + ' - ' + filter_end)

            // SEARCH
            if (filters.searchMode && task_date > filter_end) {
                // show overdue but not future
                if (myDebug.level() >= 2) console.log('- task', task)
                if (myDebug.level() >= 1) console.log('- FALSE - dates_list searchMode', task_date)
                return false;
            }
            // DASHBOARD
            let fetch_todo = filters.fetch_todo !== undefined && filters.fetch_todo;
            if (!fetch_todo) {
                if (task_date > filter_end) {
                    if (myDebug.level() >= 2) console.log('- task', task)
                    if (myDebug.level() >= 1) console.log('- FALSE - dates_list !fetch_todo', task_date)
                    return false;
                }
            }
        }
    }
    return true
}
const isTaskVisibleByMetaFilter = function (filters, task) {
    if (filters.meta_filter && filters.meta_filter === "dashboard") {
        if (task.status !== undefined && task.status) {
            if (task.status !== "new" && task.status !== "in_progress") {
                return false;
            }
        }
        if ((task.status_bit & task_status.VISIBLE) === 0) {
            return false;
        }
    }
    return true
}

const isTaskVisibleByIFollowFilter = function (filters, task) {
    if (filters.follow && filters.follow[0] === "1") {
        if (!task.followers.includes(accountState.current_account.id)) {
            return false
        }
    }
    return true
}

const isInFilterRange = function (filters, task) {
    if (filters == null) return false;
    const groups = AccountGetters.getAllAccountGroups();
    if (!isTaskVisibleByTemplateFilter(filters, task)) return false;
    if (!isTaskVisibleByOnlyTasksFilter(filters, task)) return false;
    if (!isTaskVisibleByClientFilter(filters, task)) return false;
    if (!isTaskVisibleByProjectFilter(filters, task)) return false;
    if (!isTaskVisibleByAssigneeFilter(filters, task, groups)) return false;
    if (!isTaskVisibleByDateFilter(filters, task)) return false;
    if (!isTaskVisibleByMetaFilter(filters, task)) return false;
    if (!isTaskVisibleByIFollowFilter(filters, task)) return false;
    return true;
};
const loadTaskOccurrences = function (recurrenceId, datesList) {
    return new Promise(function (resolve, reject) {
        let params = {
            dates_list: datesList
        };
        axios
            .get(Vue.config.url_prefix + "/api/tasktemplates/{0}/occurrences".format(recurrenceId), {params: params})
            .then(resp => resolve(resp.data))
            .catch(ex => reject(ex));
    });
};

const syncTaskChangesToList = function (list, filters, changedTask) {
    function getTaskFromList() {
        return list.find(
            task =>
                (task.id && changedTask.id && task.id === changedTask.id) ||
                task.virtual_id === changedTask.virtual_id
        );
    }

    function taskExistsInList() {
        return !!getTaskFromList();
    }

    function syncExistingTaskChanges() {
        let task = getTaskFromList();
        Vue.sync_item_changes(task, changedTask);
        return task;
    }

    function removeTaskIfShouldntBeVisible(_task) {
        if (!isInFilterRange(filters, _task)) {
            list.splice(list.findIndex(list_task => list_task.id === _task.id), 1);
        }
    }

    function addTaskIfShouldBeVisible(_task) {
        if (isInFilterRange(filters, _task)) {
            list.push(_task);
        }
    }

    // Logic
    let original = taskExistsInList()
        ? Vue.clone_object(getTaskFromList())
        : null;
    if (taskExistsInList()) {
        let new_task = syncExistingTaskChanges();
        removeTaskIfShouldntBeVisible(new_task);
    } else {
        addTaskIfShouldBeVisible(changedTask);
    }
    return original;
};

const syncRecurrenceChangesToList = async function (list, filters, changedTask) {
    function shouldSyncOccurrences() {
        return (
            isInFilterRange(filters, changedTask) &&
            changedTask.recurrence_rule != null &&
            (filters.only_templates === undefined || !filters.only_templates)
        );
    }

    if (list.length < 1) return;
    if (shouldSyncOccurrences()) {
        try {
            let recurrences = await loadTaskOccurrences(
                changedTask.id,
                filters.dates_list
            );
            recurrences.forEach(recurrence =>
                syncTaskChangesToList(list, filters, recurrence)
            );
        } catch (ex) {
            errorDialog.showError(ex);
        }
    }
};

const getMappedListIdentifiers = function () {
    return state.lists.map(list_name => ({
        list_key: list_name + "_list",
        filter_key: list_name + "_filters"
    }));
};

const syncTaskAndRecurrenceChangesToLists = function (changedTask) {
    syncTaskChangesToLists(changedTask);
    syncDependantTasksToLists(changedTask);
    syncRecurrenceChangesToLists(changedTask);
};

const syncDependantTasksToLists = function (changedTask) {
    getMappedListIdentifiers().forEach(({list_key, filter_key}) => {
        for (let task of state[list_key]) {
            if (task.depends_on_items) {
                for (let depends_on_item of task.depends_on_items) {
                    if (depends_on_item.id === changedTask.id) {
                        Vue.sync_item_changes(depends_on_item, changedTask)
                    }
                }
            }
        }
    });
};

const syncTaskChangesToLists = function (changedTask) {
    let ret = null;

    getMappedListIdentifiers().forEach(({list_key, filter_key}) => {
        let original_task = syncTaskChangesToList(
            state[list_key],
            state[filter_key],
            changedTask
        );
        if (original_task) ret = original_task;
    });

    return ret;
};

const syncRecurrenceChangesToLists = function (changedTask) {
    let ret = null;

    getMappedListIdentifiers().forEach(({list_key, filter_key}) => {
        let original_task = syncRecurrenceChangesToList(
            state[list_key],
            state[filter_key],
            changedTask
        );
        if (original_task) ret = original_task;
    });

    return ret;
};

let closeTask = function () {
    if (!state.task_dialog.show) return false;
    state.task_dialog.show = false;
    state.task_dialog.task_id = 0;
    state.task_dialog.client_id = 0;
    state.task_dialog.title = "";
    state.task_dialog.topic_id = 0;
    state.task_dialog.date = null;
    state.task_dialog.is_template = null;
    state.task_dialog.admin_view = false;
    state.task_dialog.model = null;
    state.task_dialog.timeEntry = null
    state.current_task = null;
    return true;
};
let shift_task_template_start_date = function (start_date, interval, type) {
    let now = new Date();
    let month_count = now.getFullYear() * 12 + now.getMonth();
    while (
        start_date.getFullYear() * 12 + start_date.getMonth() <
        month_count
        ) {
        switch (type) {
            case "monthly":
                start_date = start_date.calcAddMonths(interval);
                break;
            case "weekly":
                start_date = start_date.calcAddDays(interval * 7);
                break;
            case "yearly":
                start_date = start_date.calcAddYears(interval);
                break;
            case "quarterly":
                start_date = start_date.calcAddMonths(interval * 3);
                break;
            default:
                start_date = start_date.calcAddMonths(interval);
                break;
        }
    }
    return start_date;
};
let shift_task_template_start = function (task_template) {
    if (task_template.recurrence_rule == null) {
        // skip
    } else {
        let type = task_template.recurrence_rule.type;
        let interval =
            task_template.recurrence_rule.interval > 1
                ? task_template.recurrence_rule.interval
                : 1;
        let start_date = shift_task_template_start_date(
            parseSysDate(task_template.date),
            interval,
            type
        );
        let date = shift_task_template_start_date(
            parseSysDate(task_template.recurrence_rule.date),
            interval,
            type
        );
        task_template.date =
            formatSysDate(start_date) + task_template.date.substr(10);
        task_template.recurrence_rule.date =
            formatSysDate(date) + task_template.recurrence_rule.date.substr(10);
    }
};

function handleBulkActionError(data) {
    if (state.selectedListIds.length !== data.length) {
        const errorTotal = Math.abs(state.selectedListIds.length - data.length);
        // CODE REVIEW WITH JAANUS - const errorTotal = Math.abs((state.selectedListIds.length / 2) - data.length);
        state.bulkActionErrorsTotal = errorTotal;
    }
}

function checkMultipleAccounts() {
    let accountIds = [];
    state.selectedListIds.forEach(id => {
        const task = state.tasks_list.find(
            task => task.id === id || task.virtual_id === id
        );
        accountIds.push(task.account_id);

        state.isSameAccount = accountIds.every(
            accountId => accountId === accountIds[0]
        );
        if (state.isSameAccount === true)
            state.selectedAccountId = accountIds[0];
    });
}

function removeItemFromArray(id) {
    const index = state.selectedListIds.indexOf(id);
    if (index > -1) state.selectedListIds.splice(index, 1);
}

function sleep(ms) {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
}

export const actions = {
    syncTaskChangesToLists: syncTaskChangesToLists,
    syncRecurrenceChangesToLists: syncRecurrenceChangesToLists,
    syncTaskAndRecurrenceChangesToLists: syncTaskAndRecurrenceChangesToLists,
    closeTask: closeTask,
    openTask(id, props = null) {
        if (!id) {
            state.task_dialog.task_id = 0;
            state.task_dialog.admin_view = false;
        } else {
            state.task_dialog.task_id = id;
            // UKU-2817 Admins & Client Managers can view/edit time entries from anywhere (like in reports)
            state.task_dialog.admin_view = get(props, 'admin_view', true)
            /*
            state.task_dialog.admin_view = get(props, 'admin_view', false)
             */
        }
        state.task_dialog.client_id = get(props, 'client_id', 0)
        state.task_dialog.title = get(props, 'title', '')
        state.task_dialog.topic_id = get(props, 'topic_id', 0)
        state.task_dialog.date = get(props, 'date', null)
        state.task_dialog.is_template = get(props, 'is_template', false)
        state.task_dialog.model = get(props, 'model', null)
        state.task_dialog.is_task_button = get(props, 'is_task_button', false);
        state.task_dialog.isTaskButtonTask = get(props, 'isTaskButtonTask', false);
        state.task_dialog.project_id = get(props, 'project_id', null)
        state.task_dialog.company_id = get(props, 'company_id', 0);
        state.task_dialog.timeEntry = get(props, 'timeEntry', null)
        state.task_dialog.show = true;
    },

    loadTask(task_id, params = null) {
        return new Promise(function (resolve, reject) {
            state.current_task = null;

            if (task_id === 0) {
                let new_task = newTask(
                    0,
                    params.client_id || 0,
                    params.title,
                    params.topic_id,
                    Boolean(params.is_template)
                );

                if (params.date !== undefined && params.date != null) {
                    let d = params.date.length === 10 ? params.date + " 23:59:00" : params.date;
                    new_task.date = d;
                    new_task.due_date = d;
                }

                if (params.project_id) {
                    new_task.project_id = params.project_id
                }

                if (params.client_id !== undefined && params.client_id > 0) {
                    axios
                        .get(Vue.config.url_prefix + "/api/clients/{0}".format(params.client_id),
                            {
                                include_all_users: 0,
                                include_contacts: 0,
                                include_groups: 0
                            }
                        )
                        .then(function (resp) {
                            new_task.account_id = resp.data.account_id;
                            new_task.client_id = resp.data.id;
                            state.current_task = new_task;
                            resolve();
                        })
                        .catch(function (ex) {
                            reject(ex);
                        });
                } else {
                    state.current_task = new_task;
                    resolve();
                }

                return;
            }

            let req_params = {};
            /*
            if (params.load_available_related_tasks !== undefined) req_params.load_available_related_tasks = params.load_available_related_tasks;
            */

            axios
                .get(Vue.config.url_prefix + "/api/task/{0}".format(task_id), { // loadTask
                    params: req_params
                })
                .then(function (resp) {
                    if (resp.data.success) {
                        let task = resp.data.task;
                        if (params.action !== undefined && params.action === "task_to_template") {
                            task.id = 0;
                            task.virtual_id = null;
                            task.status = 'new';
                            task.recurrence_id = null;
                            task.recurrence_date = null;
                            task.recurrence_rule = {
                                type: "monthly",
                                date: formatSysDate(new Date()),
                                date_only: task.date_only,
                                time: task.date_only
                                    ? null
                                    : task.date.substr(11, 8),
                                day_of_month: parseSysDate(task.date).getDate(),
                                shift_to_workday: 0,
                                has_due_date: task.has_due_date,
                                due_date_only: task.due_date_only,
                                due_time: task.due_date_only
                                    ? null
                                    : task.due_date.substr(11, 8),
                                due_calc_type: "date",
                                due_day_of_month: parseSysDate(
                                    task.due_date
                                ).getDate(),
                                due_shift_to_workday: task.has_due_date ? 0 : null
                            };
                        }

                        /*if (task.recurrence_rule != null) {
                            // Change only future tasks
                            shift_task_template_start(task);
                        }*/
                        state.current_task = task;
                        /*
                        state.available_related_tasks =
                            resp.data.available_related_tasks ? resp.data.available_related_tasks : [];
                         */
                    }
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    newTask: newTask,
    postTask(data, params = null) {
        return new Promise((resolve, reject) => {
            axios
                .post("tasks/{0}".format(isNaN(data.id) ? "0" : data.id), data, {params: params})
                .then(resp => {
                    resolve(resp.data)
                })
                .catch(ex => reject(ex));
        });
    },
    deleteTask(data) {
        return new Promise(function (resolve, reject) {
            let virtual_id =
                data.id == null || data.id === 0 ? data.virtual_id : data.id;
            axios
                .delete(Vue.config.url_prefix + "/api/tasks/{0}".format(virtual_id))
                .then(function () {
                    // this is not the response from server, its just the current task object that has been deleted
                    resolve(data);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveTaskField(data, source) {
        return new Promise(function (resolve, reject) {
            let virtual_id =
                (data.id == null || data.id === 0) && data.virtual_id != null
                    ? data.virtual_id
                    : data.id;
            //todo: debug purpose only
            if (virtual_id == null) {
                data.source = source;
                appActions.systemLog(
                    "error",
                    "vue-uku/src/store/task.js",
                    "saveTaskField",
                    data
                );
            }
            axios
                .patch(Vue.config.url_prefix + "/api/tasks/{0}".format(virtual_id), data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    saveTaskComment(data) {
        return new Promise(function (resolve, reject) {
            let virtual_id =
                (data.id == null || data.id === 0) && data.virtual_id != null
                    ? data.virtual_id
                    : data.id;
            let log_id = data.log_id === undefined ? null : data.log_id;

            let params = {
                action: data.action,
                id: log_id,
                message: data.message,
                files: []
            };

            axios
                .post(Vue.config.url_prefix + "/api/tasks/{0}/logs/{1}".format(virtual_id, log_id == null ? "" : log_id), params)
                .then(function () {
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    deleteTaskComment(task_id, log_id) {
        return new Promise(function (resolve, reject) {
            axios
                .delete(Vue.config.url_prefix + "/api/tasks/{0}/logs/{1}".format(task_id, log_id))
                .then(function () {
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    fetchTasks(filters) {
        return new Promise(function (resolve, reject) {
            //let task_id = filters.task_id ? filters.task_id : "";
            state.is_loading = true;
            if (filters.meta_filter === 'calendar') {
                state.estimation_total_list = [];
            }
            axios
                .get(Vue.config.url_prefix + "/api/tasks/", {params: filters})  // fetchTasks
                .then(function (resp) {
                    resp.data.items.forEach(function (elem) {
                        if (filters.meta_filter === 'calendar' && elem.estimation) {
                            let elem_date = formatSysDate(parseSysDate(elem.date));
                            if (state.estimation_total_list[elem_date] === undefined) {
                                state.estimation_total_list[elem_date] = 0;
                            }
                            state.estimation_total_list[elem_date] += elem.estimation;
                        }
                    });
                    if (resp.data.projects !== undefined) {
                        for (let proj of resp.data.projects) {
                            syncItemToList(state.projects, proj);
                        }
                    }

                    if (filters.meta_filter === 'calendar') {
                        //no meta filter means calendar tasks
                        state.calendar_tasks_filters = filters;
                        state.calendar_tasks_list = resp.data.items;
                        state.calendar_tasks_total = resp.data.total_items;
                    } else {
                        if (filters.appendPage !== undefined && filters.appendPage) {
                            for (let i = 0; i < resp.data.items.length; i++) {
                                state.tasks_list.push(resp.data.items[i]);
                            }
                        } else {
                            state.tasks_list = resp.data.items;
                        }
                        state.tasks_filters = filters;
                        state.tasks_total = resp.data.total_items;
                    }

                    state.is_loading = false;

                    actions.fetchTaskUnreadEmails(filters)
                    resolve();
                })
                .catch(function (ex) {
                    state.is_loading = false;
                    reject(ex);
                });
        });
    },
    fetchTaskUnreadEmails(filters) {
        return new Promise(function (resolve, reject) {
            const includedViews = [
                'dashboard',
                'dashboard_search',
                'client_tasks',
                'project_tasks'
            ]

            if (!includedViews.includes(filters.meta_filter)) {
                return
            }
            const taskIds = state.tasks_list.map(x => x.id)

            if (taskIds.length) {
                axios
                    .get(Vue.config.url_prefix + "/api/task/unseen_notifications/", { params: { task_ids: taskIds } })  // fetchTasks
                    .then(function (resp) {
                        for (const item of resp.data) {
                            const taskIndex = state.tasks_list.findIndex(x => x.id === item.task_id)
                            if (taskIndex >= 0) {
                                state.tasks_list[taskIndex].unread_public_messages = item.unread_public_messages
                                state.tasks_list[taskIndex].unread_internal_comments = item.unread_internal_comments
                            }
                        }

                        resolve();
                    })
                    .catch(function (ex) {
                        reject(ex);
                    });
            }
        });
    },
    clearTasks(props = {}) {
        if (props.calendar !== undefined && props.calendar === true) {
            state.calendar_tasks_filters = null;
            state.calendar_tasks_list = [];
            state.calendar_tasks_total = 0;
        } else if (props.recurring !== undefined && props.recurring === true) {
            state.recurring_tasks_filters = null;
            state.recurring_tasks_list = [];
        } else {
            state.tasks_filters = null;
            state.tasks_list = [];
            state.tasks_list_total = 0;
        }
    },
    fetchMonthInfo(country_code, monthyear) {
        let url = Vue.config.url_prefix + "/api/calendar/month-info/{0}/{1}".format(country_code, monthyear)
        return new Promise(function (resolve, reject) {
            axios
                .get(url)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    fetchTaskTemplates(object_id) {
        return new Promise(function (resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/tasktemplates/", {
                    params: {object_id: object_id}
                })
                .then(function (resp) {
                    state.recurring_tasks_filters = {
                        client_id: object_id,
                        only_templates: true
                    };
                    state.recurring_tasks_list = resp.data;
                    resolve();
                })
                .catch(function (ex) {
                    reject(ex);
                });
        });
    },
    async fetchTaskAssignees({account_id, client_id}) {
        return await task_assignees.get({account_id, client_id});
    },
    async deleteJobTemplate(data) {
        try {
            const res = await axios.delete(
                Vue.config.url_prefix +
                "/api/tasktemplates/{0}".format(data.id),
                {params: {client_id: data.id}}
            );

            return res.data;
        } catch (ex) {
            return 0;
        }
    },
    async reorderCalendarTasks({sorted_task_ids_list, date}) {
        return await task_order.post({sorted_task_ids_list, date});
    },
    async fetchTaskOrders(start_date, end_date) {
        return await task_order.get({start_date, end_date});
    },
    loadTaskTemplates(object_type, object_id) {
        return new Promise((resolve, reject) => {
            axios
                .get("tasktemplates/", {
                    params: {object_type, object_id}
                })
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    async fetchTaskTemplatesByAccount(account_id, is_client_portal=false) {
        try {
            const _url = is_client_portal ? `/tasktemplates/account/${account_id}?is_client_portal=1` : `/tasktemplates/account/${account_id}`
            const {data} = await axios.get(_url);

            return data;
        } catch (ex) {
            console.log(ex);
        }
    },
    saveTaskTemplates(/*object_type, object_id,*/ data) {
        return new Promise(function (resolve, reject) {
            //let url = "tasktemplates/{0}/{1}".format(object_type, object_id);
            axios
                .post("tasktemplates/", data)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    async autoSuggestSearch(keyword) {
        // notice :: this is global search
        return await toolbar_search.get(keyword);
    },
    autoSuggestTasks({keyword, client_id}) {
        return new Promise(function (resolve, reject) {
            keyword = keyword.replace("+", "%2B");
            // console.log('autoSuggestTasks: ', keyword)
            axios
                .get(Vue.config.url_prefix + "/api/dispatcher/", {
                    params: {
                        action: "get_tasks_and_clients_autocomplete",
                        keyword: keyword,
                        client_id: client_id
                    }
                })
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex));
        });
    },
    getTask(id) {
        return state.tasks_list.find(
            task => Number(task.id) === Number(id) || task.virtual_id === id
        );
    },
    getTaskId: task => {
        return task.id ? Number(task.id) : task.virtual_id;
    },
    getTaskIdKey: task => {
        return task.id ? "id" : "virtual_id";
    },
    get_task_assigned_names: assignees => {
        if (assignees == null) return [];
        return assignees
            .map(assignee => assignee["assigned_full_name"])
            .join(", ");
    },
    shiftTaskTemplateStart: shift_task_template_start,

    //bulk actions:
    setSelectedListIds(id) {
        state.bulkActionErrorsTotal = null;

        const index = state.selectedListIds.indexOf(id);
        if (index === -1) {
            state.selectedListIds.push(id);
        } else {
            state.selectedListIds.splice(index, 1);
        }
        /* CODE REVIEW WITH JAANUS
        const virtualId = state.tasks_list.find(
            task => task.id === id || task.virtual_id === id
        ).virtual_id;

        const index = state.selectedListIds.indexOf(id);
        const virtualIndex = state.selectedListIds.indexOf(id);

        if (index === -1 && virtualIndex === -1) {
            state.selectedListIds.push(id, virtualId);
        } else {
            state.selectedListIds.splice(index, 1);
            state.selectedListIds.splice(virtualIndex, 1);
        }
        */
        checkMultipleAccounts();
    },

    removeFromSelectedListIds(id) {
        removeItemFromArray(id);
    },

    clearAllSelectedListIds() {
        if (state.selectedListIds.length > 0) {
            state.selectedListIds = [];
            state.bulkActionErrorsTotal = null;
        }
    },

    async setImportant(actionValue) {
        try {
            state.isBulkActionLoading = true;

            await sleep(1200);
            const {data} = await axios.patch("/tasks-action/set-important", {
                task_ids: state.selectedListIds,
                action_value: actionValue === true ? 1 : 0
            });

            state.tasks_list.forEach(task => {
                data.forEach(item => {
                    if (item.success) {
                        if (
                            task.id == item.task_id ||
                            task.id == item.virtual_id
                        ) {
                            if (actionValue === true) {
                                task.is_important = 1;
                            } else {
                                task.is_important = 0;
                            }
                        }
                    }
                });
            });
            state.isBulkActionLoading = false;
            handleBulkActionError(data);
        } catch (ex) {
            state.isBulkActionLoading = false;

            console.error("Bulk action error", ex);
        }
    },

    async setExtraWork(actionValue) {
        try {
            state.isBulkActionLoading = true;

            await sleep(1200);
            const {data} = await axios.patch("/tasks-action/set-extra-work", {
                task_ids: state.selectedListIds,
                action_value: actionValue === true ? 1 : 0
            });

            state.tasks_list.forEach(task => {
                data.forEach(item => {
                    if (item.success) {
                        if (
                            task.id == item.task_id ||
                            task.id == item.virtual_id
                        ) {
                            if (actionValue === true) {
                                task.is_extra = 1;
                            } else {
                                task.is_extra = 0;
                            }
                        }
                    }
                });
            });

            state.isBulkActionLoading = false;
            handleBulkActionError(data);
        } catch (ex) {
            state.isBulkActionLoading = false;

            console.error("Bulk action error", ex);
        }
    },

    async setTasksAssignees(selectedUserIds) {
        try {
            state.isBulkActionLoading = true;

            await sleep(1200);
            const {data} = await axios.patch(
                "/tasks-action/set-tasks-assignees",
                {
                    task_ids: state.selectedListIds,
                    assignees: selectedUserIds
                }
            );

            state.tasks_list.forEach(task => {
                data.forEach(resTask => {
                    if (resTask.id === task.id) {
                        task.assignees_data = resTask.assignees_data;
                    }
                });
            });

            state.isBulkActionLoading = false;

            handleBulkActionError(data);
        } catch (ex) {
            state.isBulkActionLoading = false;

            console.error("Bulk action error", ex);
        }
    },

    async setMarkDone() {
        try {
            state.isBulkActionLoading = true;

            await sleep(1200);
            state.markDoneErrorsTotal = null;
            const {data} = await axios.patch("/tasks-action/set-mark-done", {
                task_ids: state.selectedListIds
            });

            state.isBulkActionLoading = false;

            let errorCount = 0;
            data.forEach(item => {
                if (item.success == 0) errorCount += 1;
                else {
                    removeItemFromArray(item.task_id);
                    removeItemFromArray(item.virtual_id);
                }
            });

            state.markDoneErrorsTotal = errorCount;
            state.bulkActionErrorsTotal = errorCount;
        } catch (ex) {
            state.isBulkActionLoading = false;

            console.error("Bulk action error", ex);
        }
    },

    async deleteTasks() {
        try {
            state.isBulkActionLoading = true;

            await sleep(1200);
            state.deleteTasksErrors = [];

            const {data} = await axios.delete("/tasks-action/delete", {
                data: {
                    task_ids: state.selectedListIds
                }
            });
            state.isBulkActionLoading = false;

            let errorCount = 0;
            let uniqueErrors = [];
            data.forEach(item => {
                if (item.success === 0) {
                    if (!uniqueErrors.includes(item.error)) uniqueErrors.push(item.error)
                } else {
                    removeItemFromArray(item.task_id);
                    removeItemFromArray(item.virtual_id);
                }
            });

            state.deleteTasksErrors = uniqueErrors;
            state.bulkActionErrorsTotal = errorCount;
        } catch (ex) {
            state.isBulkActionLoading = false;

            console.error("Bulk action error", ex);
        }
    },

    async snoozeTasks({date, due_date}) {
        try {
            state.isBulkActionLoading = true;

            await sleep(1200);
            const {data} = await axios.patch("/tasks-action/snooze-tasks", {
                task_ids: state.selectedListIds,
                date,
                due_date
            });

            state.isBulkActionLoading = false;

            state.selectedListIds = [];
        } catch (ex) {
            state.isBulkActionLoading = false;

            console.error("Bulk action error", ex);
        }
    },

    async saveTimeEntries(
        billable,
        startTime,
        endTime,
        duration,
        personId,
        calendarDate,
        splitDuration
    ) {
        try {
            state.isBulkActionLoading = true;
            state.saveTaskTimeEntriesErrorsTotal = null

            await sleep(1200);
            const {data} = await axios.patch("/tasks-action/time-entries", {
                task_ids: state.selectedListIds,
                billable,
                end:
                    endTime === null
                        ? null
                        : calendarDate + " " + endTime,
                start:
                    startTime === null
                        ? null
                        : calendarDate + " " + startTime,
                person_id: personId,
                is_split_duration: splitDuration === true ? 1 : 0,
                duration: duration
            });

            state.isBulkActionLoading = false;

            let errorCount = 0;
            data.forEach(item => {
                if (item.success == 0) errorCount += 1;
            });

            state.saveTaskTimeEntriesErrorsTotal = errorCount;
            state.bulkActionErrorsTotal = errorCount;
        } catch (ex) {
            state.isBulkActionLoading = false;

            errorDialog.showError(ex);
            console.error("Bulk action error", ex);
        }
    }
};

export const getters = {
    tasks: computed(() => state.tasks_list),
    calendar_tasks: computed(() => state.calendar_tasks_list),
    recurringTasks: computed(() => state.recurring_tasks_list),
    currentMonthTasks: computed(() => {
        const cur_month = formatSysDate(new Date()).substr(0, 8);
        return state.tasks_list.filter(
            t =>
                t.calc_status === "overdue" ||
                (t.date && t.date.substr(0, 8) === cur_month) ||
                (t.due_date && t.due_date.substr(0, 8) === cur_month)
        );
    }),
    startOfSelectedWeek: computed(() => {
        return formatSysDate(parseSysDate(state.selected_date).calcWeekStart(Vue.formatting.first_week_day));
    }),
    getEndOfSelectedWeek: weeks =>
        computed(() => {
            return formatSysDate(
                parseSysDate(state.selected_date)
                    .calcAddDays((weeks - 1) * 7)
                    .calcWeekEnd(Vue.formatting.first_week_day)
            );
        })
};

export const key = Symbol("TaskModule");

export const provideTask = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
